import React, { useState } from 'react';
import './CourseEditModal.css';

export default function CourseEditModal({ data, onClose, onSave }) {
  const [form, setForm] = useState({ ...data });
  const [csvHeader, setCsvHeader] = useState([]);
  const [csvRows, setCsvRows] = useState([]);
  const [mapping, setMapping] = useState({});
  const [selectedRows, setSelectedRows] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCsvUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    const reader = new FileReader();
    reader.onload = (event) => {
      const csvText = event.target.result;
      const rows = csvText
        .split('\n')
        .map(line => line.split(';').map(cell => cell.trim()))
        .filter(row => row.length > 1);
  
      if (!rows.length) {
        alert("CSV scheint leer zu sein");
        return;
      }
  
      const header = rows[0];
      const veranstaltungIndex = header.findIndex(h => h.toLowerCase().includes('veranstaltung'));
  
      if (veranstaltungIndex === -1) {
        alert("Spalte 'Veranstaltung' nicht gefunden");
        return;
      }
  
      const normalizedTitle = data.course_title.toLowerCase();
  
      const matching = rows.slice(1).filter(row =>
        row[veranstaltungIndex]?.toLowerCase().includes(normalizedTitle)
      );
  
      if (matching.length === 0) {
        alert("Keine passenden Einträge in 'Veranstaltung' gefunden.");
        return;
      }
  
      setCsvRows(matching);
  
      const guess = (name) => {
        const n = name.toLowerCase();
        if (n.includes('datum')) return 'date';
        if (n.includes('zeit') || n.includes('uhr')) return 'time';
        if (n.includes('raum')) return 'room';
        if (n.includes('dozent')) return 'lecturer';
        if (n.includes('ort')) return 'location';
        return '';
      };
  
      const autoMap = {};
      header.forEach((h, i) => {
        autoMap[i] = guess(h);
      });
  
      setMapping(autoMap);
  
      const defaultSelections = {};
      matching.forEach((_, i) => defaultSelections[i] = true);
      setSelectedRows(defaultSelections);
    };
  
    reader.readAsText(file, 'ISO-8859-1'); // ggf. 'utf-8'
  };
  
  
  
  

  const handleSubmit = async () => {
    const dates = csvRows
      .filter((_, i) => selectedRows[i])
      .map(row => {
        const get = (key) => {
          const col = Object.keys(mapping).find(k => mapping[k] === key);
          return row[col] || '';
        };
        return {
          date: get('date'),
          time: get('time'),
          room: get('room'),
          lecturer: get('lecturer'),
          location: get('location'),
        };
      });

    const payload = {
      course: form,
      dates,
    };

    const res = await fetch('http://localhost/App/backend-web/duplicate_course.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    alert(result.message);
    onSave();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h3>Kurs kopieren & bearbeiten</h3>

        <label>Semester (z. B. SS2026):</label>
        <input name="course_semester_description" value={form.course_semester_description} onChange={handleChange} />

        <label>Datum von:</label>
        <input name="course_date_from" value={form.course_date_from} onChange={handleChange} />

        <label>Zeit (z. B. 10:00-12:00):</label>
        <input name="course_time" value={form.course_time} onChange={handleChange} />

        <label>Raum:</label>
        <input name="course_location" value={form.course_location} onChange={handleChange} />

        <label>Beschreibung:</label>
        <textarea name="course_description" value={form.course_description} onChange={handleChange} />

        <hr />
        <label>Neue Termine aus CSV importieren:</label>
        <input type="file" accept=".csv" onChange={handleCsvUpload} />

        {csvRows.length > 0 && (
          <>
            <p><strong>{csvRows.length} Zeilen erkannt. Zuordnung:</strong></p>
            <ul>
              {Object.entries(mapping).map(([index, field]) => (
                <li key={index}>
                  Spalte {parseInt(index) + 1}: <code>{field || '–'}</code>
                </li>
              ))}
            </ul>

            <button onClick={() => {
              const all = {};
              csvRows.forEach((_, i) => all[i] = true);
              setSelectedRows(all);
            }}>
              Alle auswählen
            </button>

            <table className="csv-preview">
              <thead>
                <tr>
                  <th>✓</th>
                  {csvHeader.map((_, i) => (
                    <th key={i}>
                      <select
                        value={mapping[i] || ''}
                        onChange={(e) => setMapping({ ...mapping, [i]: e.target.value })}
                      >
                        <option value="">-- Feld --</option>
                        <option value="date">Datum</option>
                        <option value="time">Uhrzeit</option>
                        <option value="room">Raum</option>
                        <option value="lecturer">Dozent</option>
                        <option value="location">Ort</option>
                      </select>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvRows.slice(0, 10).map((row, i) => (
                  <tr key={i}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows[i] ?? true}
                        onChange={(e) => setSelectedRows(prev => ({
                          ...prev,
                          [i]: e.target.checked
                        }))}
                      />
                    </td>
                    {row.map((cell, j) => (
                      <td key={j}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        <button onClick={handleSubmit}>Neue Instanz speichern</button>
        <button onClick={onClose} className="secondary">Abbrechen</button>
      </div>
    </div>
  );
}
